$(document).ready(function () {
  const $boxes = $('.rnk-new-generic-shelf-slider');

  $boxes.each((i, e) => {
    const $box = $(e);

    if ($box.find('.track-shelf').length) {

      $box.find('.track-shelf').addClass('splide__track');
      $box.find('.splide__track > ul').addClass('splide__list');
      $box.find('.splide__list li:not(.helperComplement)').addClass('splide__slide');

      const boxObj = {
        id: {
          perPage: $box.data('per-page'),
          slider: $box.find('.splide'),
          track: $box.find('.splide__track'),
          list: $box.find('.splide__list'),
        },
      };
      let slider = window.storeTheme.helpers.slider($box.find('.splide')[0], {
        perPage: 2,
        breakpoints: { 992: { perPage: 2 } },
      });

      slider.mount();
      $box.find('.splide').addClass('slider-ready');
    }

  });
});

export default {};